"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestStatusFactory = exports.RequestStatus = exports.RequestStatusValue = exports.RequestType = void 0;
var RequestType;
(function (RequestType) {
    RequestType["FETCH"] = "FETCH";
    RequestType["UPDATE"] = "UPDATE";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
var RequestStatusValue;
(function (RequestStatusValue) {
    RequestStatusValue["STANDBY"] = "STANDBY";
    RequestStatusValue["BUSY"] = "BUSY";
    RequestStatusValue["SUCCESS"] = "SUCCESS";
    RequestStatusValue["FAILURE"] = "FAILURE";
})(RequestStatusValue = exports.RequestStatusValue || (exports.RequestStatusValue = {}));
class RequestStatus {
    constructor(type = RequestType.FETCH, value = RequestStatusValue.STANDBY) {
        this.type = type;
        this.value = value;
    }
    get isFetch() {
        return this.type === RequestType.FETCH;
    }
    get isUpdate() {
        return this.type === RequestType.UPDATE;
    }
    get isStandby() {
        return this.value === RequestStatusValue.STANDBY;
    }
    get isBusy() {
        return this.value === RequestStatusValue.BUSY;
    }
    get isSuccess() {
        return this.value === RequestStatusValue.SUCCESS;
    }
    get isFailure() {
        return this.value === RequestStatusValue.FAILURE;
    }
    get isComplete() {
        return (this.value === RequestStatusValue.SUCCESS ||
            this.value === RequestStatusValue.FAILURE);
    }
}
exports.RequestStatus = RequestStatus;
exports.RequestStatusFactory = {
    fetch: {
        standby: () => new RequestStatus(RequestType.FETCH, RequestStatusValue.STANDBY),
        busy: () => new RequestStatus(RequestType.FETCH, RequestStatusValue.BUSY),
        success: () => new RequestStatus(RequestType.FETCH, RequestStatusValue.SUCCESS),
        failure: () => new RequestStatus(RequestType.FETCH, RequestStatusValue.FAILURE)
    },
    update: {
        standby: () => new RequestStatus(RequestType.UPDATE, RequestStatusValue.STANDBY),
        busy: () => new RequestStatus(RequestType.UPDATE, RequestStatusValue.BUSY),
        success: () => new RequestStatus(RequestType.UPDATE, RequestStatusValue.SUCCESS),
        failure: () => new RequestStatus(RequestType.UPDATE, RequestStatusValue.FAILURE)
    }
};
//# sourceMappingURL=status.js.map